const React = require("react");
const {FormWrapper, FormFooterAgreement} = require("../../../../../dumb/FormHandlers");
const {apiAdminForceRetailerSignOut} = require("../../../../../../api/admin/retailers");

module.exports = ({data, update, close}) => {

  const resultModalData = [
    'Sign out completed',
    `We've closed session for the #${data.id} retailer.`
  ];

  const onSubmit = () => (
    apiAdminForceRetailerSignOut({merchant_id: data.id})
  );

  const onResult = () => {
    update();
    close();
  }

  return (
    <FormWrapper
      onSubmit={onSubmit}
      resultModalData={resultModalData}
      onResult={onResult}
    >{(formCtx) => (
        <FormFooterAgreement
          submitBtnData={{
            text: 'Proceed',
            formCtx
          }}
          additionalBtnsList={[
            {
              text: 'Cancel',
              onClick: close
            }
          ]}
        />
    )}</FormWrapper>
  )
}
